import { Alert, Container } from "react-bootstrap"
import { Link } from "react-router-dom"
import { ReactNode } from "react"

interface DisplayErrorMessageProps {
  children?: ReactNode
  showDashButton?: boolean
}

const DisplayErrorMessage = ({ children, showDashButton }: DisplayErrorMessageProps): JSX.Element => {
  return (
    <Container className="d-flex flex-column align-items-center position-relative" style={{ paddingTop: "4.8375rem" }}>
      <Alert style={{ maxWidth: "400px" }} variant="danger">{children || "An error occurred. Please try again later."}</Alert>
      {showDashButton && (
        <Link to="/" className="btn rounded-3 mt-5 p-3 btn-secondary">
          Back to Dashboard
        </Link>
      )}
    </Container>
  )
}
export default DisplayErrorMessage